import findIndex from 'lodash/findIndex';
import {
  ENDPOINT_DELETE_SUCCESS,
  ENDPOINT_SAVE_SUCCESS,
} from 'actions/endpointsModal';
import {
  FBI_FETCH_PLAN_ENDPOINT_START,
  FBI_FETCH_PLAN_ENDPOINT_SUCCESS,
  FBI_FETCH_PLAN_ENDPOINT_FAILURE,
  IB_ENDPOINT_CREATED,
  FBI_EDIT_NODE_END,
} from 'actions/flowBlockInput';

export const INITIAL_STATE = {
  endpoints: [],
};

// Both flowBlockInput.endpoints and endpointsModal.endpoints contain up-to-date endpoints;
// therefore, this FBI reducer should also handles endpointsModal actions.
export default function endpointsLoadReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FBI_FETCH_PLAN_ENDPOINT_START:
      return {
        ...state,
      };
    case FBI_FETCH_PLAN_ENDPOINT_SUCCESS:
      return {
        ...state,
        endpoints: action.payload.data,
      };
    case FBI_FETCH_PLAN_ENDPOINT_FAILURE:
      return {
        ...state,
      };
    case ENDPOINT_SAVE_SUCCESS:
    case IB_ENDPOINT_CREATED: {
      const endpoints = state.endpoints ? [...state.endpoints] : [];
      const prevIndex = findIndex(endpoints, e => e.id === action.payload.id);
      const index = prevIndex === -1 ? endpoints.length : prevIndex;
      endpoints[index] = action.payload;
      return {
        ...state,
        endpoints,
      };
    }
    case ENDPOINT_DELETE_SUCCESS:
      return {
        ...state,
        endpoints: state.endpoints.filter(
          endpoint => endpoint.id !== action.payload.id,
        ),
      };
    case FBI_EDIT_NODE_END:
      return INITIAL_STATE;
    default:
      return state;
  }
}
